import React from "react";
import { Card, Carousel, Col, Row } from "react-bootstrap";
import Title from "../assets/title-border.png";

const Testimonials = () => {
  return (
    <>
      <Row className="px-5 pt-4 mx-0 bg-white">
        <Col>
          <h2 className="text-center pb-0">
            <span>Happy Candidates</span> <br />
            <img src={Title} alt="border" className="title-border" />
          </h2>
        </Col>
      </Row>
      <Row className="stud-test mx-0 bg-white">
        <Col className="testmonials d-flex justify-content-center">
          <Carousel>
            <Carousel.Item className="text-center">
              <p className="d-flex align-items-center mb-0">
                <i className="fas fa-quote-left fs-1"></i>
                <span className="px-3 text-center">
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Blanditiis obcaecati, voluptatum <br /> expedita quaerat
                  itaque alias iusto officia in autem ullam.
                </span>
                <i className="fas fa-quote-right fs-1"></i>
              </p>
              <i className="fa fa-user-circle"></i>
              <h5 className="fw-bold service-title pt-1 my-0">Jagadeesh P</h5>
              <p className="pb-3">IT-Software/Software Services</p>
            </Carousel.Item>
            <Carousel.Item className="text-center">
              <p className="d-flex align-items-center mb-0">
                <i className="fas fa-quote-left fs-1"></i>
                <span className="px-3 text-center">
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Blanditiis obcaecati, voluptatum <br /> expedita quaerat
                  itaque alias iusto officia in autem ullam.
                </span>
                <i className="fas fa-quote-right fs-1"></i>
              </p>
              <i className="fa fa-user-circle"></i>
              <h5 className="fw-bold service-title pt-1 my-0">Jagadeesh P</h5>
              <p className="pb-3">IT-Software/Software Services</p>
            </Carousel.Item>
          </Carousel>
        </Col>
      </Row>
    </>
  );
};

export default Testimonials;
